var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeedTestPlanSpeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.3139,
    height: 33.3139,
    rx: 16.6569,
    fill: "#F1F5F9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 24.314C12.4456 24.314 9 20.8683 9 16.657C9 12.4456 12.4456 9 16.657 9C20.8683 9 24.314 12.4456 24.314 16.657C24.314 20.8683 20.8683 24.314 16.657 24.314ZM16.657 10.5314C13.2879 10.5314 10.5314 13.2879 10.5314 16.657C10.5314 20.0261 13.2879 22.7826 16.657 22.7826C20.0261 22.7826 22.7826 20.0261 22.7826 16.657C22.7826 13.2879 20.0261 10.5314 16.657 10.5314Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5849 17.729C14.9723 17.1164 13.4409 13.3645 13.4409 13.3645C13.4409 13.3645 17.1928 14.8959 17.8054 15.5085C18.418 16.121 18.418 17.0399 17.8054 17.6524C17.1163 18.3415 16.1974 18.3415 15.5849 17.729Z",
    fill: "#475569"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedTestPlanSpeed);
export default __webpack_public_path__ + "static/media/SpeedTestPlanSpeed.b8df0bc659f928e52e26a6c22232ad56.svg";
export { ForwardRef as ReactComponent };